import styled from "styled-components";

const UIconWrapper = styled.div`
  margin-right: 7px;
`;

export default UIconWrapper;
